<!--
グラフ出力画面
URL：/graph/product
-->

<template>
  <div>
    <v-container v-show="this.$parent.dispFlag.graph">
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-tabs
        v-model="tabIndex"
        centered
        color="white"
        center-active
        active-class="tab-active"
      >
        <v-tabs-slider color="transparent"></v-tabs-slider>
        <v-tab
          class="tab-item"
          style="width: 0px; padding: 0px; min-width: 0px"
        />
        <v-tab
          class="tab-item"
          style="font-size: 16pt"
          v-for="item in tabItems"
          :key="item.key"
          @click.stop="item.callback"
        >
          {{ item.label }}
          <span v-if="item.notice" class="notice">！</span>
        </v-tab>
      </v-tabs>

      <v-row justify="center" style="margin-top: 10px">
        <v-col cols="auto" style="text-align: left;padding: 0px; width: 235px">
          <v-btn-toggle  v-if="this.$parent.dispFlag.doubling" v-model="selectedDoubling" @change="onChangeDoubling" color="green" dense mandatory>
            <v-btn :value="1">二倍体</v-btn>
            <v-btn :value="2">三倍体</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="auto" style="text-align: right;padding: 0px; width: 235px">
          <p style="font-size: 20px; margin: 0px">{{ totalCount }}</p>
        </v-col>
      </v-row>
      <v-row justify="center" style="text-align: right; margin-top: 10px">
        <v-col cols="auto" style="padding: 0px; width: 470px">
          <p style="font-size: 20px; margin: 0px">{{ detailData }}</p>
        </v-col>
      </v-row>
      <v-row justify="center" style="text-align: center; margin-top: 10px">
        <v-col
          cols="auto"
          style="display: flex; align-items: center; padding: 10px"
        >
          <v-card elevation="0" class="ma-4; overflow-x-auto" outlined>
            <v-card-text>
              <v-row>
                <v-col cols="auto" style="width: 470px; margin-right: 20px">
                  <GChart
                    :type="chartType"
                    :data="chartData"
                    :options="chartOptions"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        style="text-align: center; margin-top: 10px"
        v-show="dispPagenationFlag"
      >
        <v-col cols="auto" style="padding: 0px; width: 1000px">
          <month-picker-graph
            ref="month_picker_graph"
            @on-select-calendar-month="onSelectCalenderMonth"
          ></month-picker-graph>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MonthPickerGraph from "../graph-sub-contents/month-picker-graph.vue";
import { GChart } from "vue-google-charts/legacy";
import Alert from "../common/alert.vue";
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  components: {
    "month-picker-graph": MonthPickerGraph,
    GChart,
    alert: Alert,
  },
  data() {
    // グラフ表示
    this.graphKindName = "";
    this.dispYear1 = "";
    this.dispYear2 = "";
    this.uid = "";
    this.summary_type = "";
    this.summary_data = [];
    this.product_record_update_date = "";
    this.dispPagenationFlag = false;
    this.date_type = "";
    this.chartType = "";
    this.chartData = [];
    this.chartDataRsv = [];

    // グラフ表示オプション設定
    this.chartOptions = {
      // グラフ表示枠の幅(初期値)
      width: 0,
      // グラフ表示枠の高さ
      height: 0,
      // グラフ表示枠の左端からの有効位置(px)と領域使用率
      chartArea: {
        left: 85,
        width: "100%",
      },
      bar: {
        // グラフ棒各幅を100%に設定
        groupWidth: "100%",
      },
      // 凡例の表示位置(下部)の設定
      legend: {
        position: "bottom",
      },
    };
    // 累計数量(対象シーズン毎)
    this.totalValue1 = 0; // 表示年1累計値
    this.totalValue2 = 0; // 表示年2累計値
    // 前年比
    this.yearOnyear = "";
    // 累計数量
    this.totalValue = 0;
    // 累計数量
    this.totalCount = "";
    // 詳細情報
    this.detailData = "";

    // 累計数量(累計グラフ用)
    this.sumTotalAmount1 = 0; // 表示年1累計値
    this.sumTotalAmount2 = 0; // 表示年2累計値
    this.sumTotalAmount3 = 0; // 表示年2累計値

    this.$nextTick(() => {});

    // 区分(1:通常（二倍体）2:三倍体)切替経由フラグ
    this.fromChangeDoubling = false;

    // 週別選択月保持用
    this.selectMonthRsv = "0";

    return {
      // エラー情報初期化
      errors: [],
      // グラフ表示オプション設定値反映
      chartOptions: this.chartOptions,
      // 月別ボタン選択状態
      tabIndex: 1,
      // グラフデータ
      chartData: [],
      // 区分(1:通常（二倍体）2:三倍体)
      selectedDoubling: 1,
    };
  },
  methods: {
    /**
     * カレンダーで選択した月に対してグラフ出力する
     */
    onSelectCalenderMonth(selectMonth) {
      // 選択月を保持
      this.selectMonthRsv = Number(selectMonth.substring(5, 7)).toString();

      this.dispGraphData(Number(selectMonth.substring(5, 7)).toString());
    },

    /**
     * 選択したページ番号に対応するグラフを出力する
     */
    dispGraphData(selectMonth) {
      var row;
      var chartDataSub = [];
      var stackedCnt = 0;

      // ヘッダ情報を設定
      chartDataSub.push(this.chartDataRsv[0]);

      // 指定月毎にグラフデータ設定
      switch (selectMonth) {
        case "7":
        case "8":
        case "9":
        case "10":
        case "11":
        case "12":
        case "3":
        case "4":
        case "5":
        case "6":
          // 全データリストのうち当年n月分又は、翌年n月分のみ切り出す
          for (row of this.chartDataRsv) {
            if (stackedCnt > 0 || row[0].indexOf(selectMonth + "月") != -1) {
              chartDataSub.push(row);
              // 積み上げグラフの場合は1セット2本のデータのため後ろ1本もpushさせる
              if (this.chartOptions.isStacked) {
                stackedCnt++;
                if (stackedCnt > 1) stackedCnt = 0;
              }
            }
          }
          break;
        case "1":
        case "2":
          // 全データリストのうち翌年1月分のみ切り出す
          for (row of this.chartDataRsv) {
            if (stackedCnt > 0 || 
              (row[0].indexOf("1" + selectMonth + "月") == -1 &&
              row[0].indexOf(selectMonth + "月") != -1)
            ) {
              chartDataSub.push(row);
              // 積み上げグラフの場合は1セット2本のデータのため後ろ1本もpushさせる
              if (this.chartOptions.isStacked) {
                stackedCnt++;
                if (stackedCnt > 1) stackedCnt = 0;
              }
            }
          }
          break;
      }
      // グラフオブジェクトに表示データ設定
      this.chartData = chartDataSub;
    },
    /**
     * 月別グラフ表示用データを設定する
     */
    setDataMonth(
      graphKindName,
      dispYear1,
      dispYear2,
      uid,
      summary_type,
      summary_data,
      product_record_update_date,
      dispPagenationFlag
    ) {
      // 表示データ(グラフの種類)
      this.graphKindName = graphKindName;
      // 表示年1
      this.dispYear1 = dispYear1;
      // 表示年2
      this.dispYear2 = dispYear2;
      // ユーザーID
      this.uid = uid;
      // 集計種別
      this.summary_type = summary_type;
      // API取得集計データ
      this.summary_data = summary_data;
      // 生産情報更新日時
      this.product_record_update_date = product_record_update_date;
      // ページネーション出力フラグ
      this.dispPagenationFlag = dispPagenationFlag;

      // 月別ボタン選択状態
      this.tabIndex = 1;
      // 累計数量(対象シーズン毎)初期化
      this.totalValue1 = 0;
      this.totalValue2 = 0;
      // 前年比初期化
      this.yearOnyear = "";
      // 累計数量初期化
      this.totalValue = 0;
      // 出力メッセージ領域クリア
      this.clearMessage();

      // 凡例ラベル設定(R:令和)
      if (this.summary_data.length > 0) {
        var annotation1 = "R" + (this.dispYear1 - 2018);
        var annotation2 = "R" + (this.dispYear2 - 2018);
      }

      // 更新日時
      var productRecordUpdateDate = this.product_record_update_date.replaceAll(
        "-",
        "/"
      );

      // グラフ表示データ格納用
      var chartDataSub = [];
      var chartDataUsrCnt = [];
      var cnt, cnt_sub;
      var row1, row2, row3, row4;
      var cntlFalg = false;
      var rsvUser = "";
      var rsvMw = "";
      this.date_type = "month";
      // 表示対象種別毎にグラフ(デフォルト用)情報を設定する
      switch (this.graphKindName) {
        case "むき身総出荷量の推移":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            ["時期", annotation1 + "シーズン", annotation2 + "シーズン"],
            ["10月", 0, 0],
            ["11月", 0, 0],
            ["12月", 0, 0],
            ["1月", 0, 0],
            ["2月", 0, 0],
            ["3月", 0, 0],
            ["4月", 0, 0],
            ["5月", 0, 0],
            ["6月", 0, 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")
                ) {
                  chartDataSub[cnt][1] =
                    chartDataSub[cnt][1] + row1.total_amount;
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row3 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")
                ) {
                  chartDataSub[cnt][2] =
                    chartDataSub[cnt][2] + row1.total_amount;
                  // 表示年2用累計数量を蓄積
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合のみ増減率算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1 / 1000).toFixed(1) + "トン";
          break;
        case "生産者当たり水揚げ量の比較":
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            [
              "時期",
              annotation1 + "自分",
              annotation2 + "自分",
              annotation1 + "県平均",
            ],
            ["10月", 0, 0, 0],
            ["11月", 0, 0, 0],
            ["12月", 0, 0, 0],
            ["1月", 0, 0, 0],
            ["2月", 0, 0, 0],
            ["3月", 0, 0, 0],
            ["4月", 0, 0, 0],
            ["5月", 0, 0, 0],
            ["6月", 0, 0, 0],
          ];
          // 情報設定(集計対象のユーザー数をセットする)
          chartDataUsrCnt = [
            ["時期", "ユーザー数"],
            ["10月", 0],
            ["11月", 0],
            ["12月", 0],
            ["1月", 0],
            ["2月", 0],
            ["3月", 0],
            ["4月", 0],
            ["5月", 0],
            ["6月", 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            cnt_sub = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][1] =
                      chartDataSub[cnt][1] + row1.total_amount;
                    // 表示年1用累計数量を蓄積
                    this.totalValue1 = this.totalValue1 + row1.total_amount;
                  }
                  chartDataSub[cnt][3] =
                    chartDataSub[cnt][3] + row1.total_amount;
                  break;
                } else if (
                  ((row1.month_week_num.substring(0 ,2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))) &&
                  (row1.uid == this.uid)
                ) {
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
              for (row3 of chartDataUsrCnt) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")
                ) {
                  // 同月内は異なるユーザーのみカウントする
                  if (
                    rsvUser != row1.uid ||
                    rsvMw != row1.month_week_num.substring(0, 2)
                  ) {
                    chartDataUsrCnt[cnt_sub][1] =
                      chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = row1.month_week_num.substring(0, 2);
                  }
                  break;
                }
                cnt_sub++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row4 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row4[0].toString().replace("月", "")
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][2] =
                      chartDataSub[cnt][2] + row1.total_amount;
                    // 表示年2用累計数量を蓄積
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                  ) {
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                    break;
                  }
                cnt++;
              }
            }
          }
          // 県平均値を算出する(小数点第2位を四捨五入)
          this.culcAverage(chartDataSub,chartDataUsrCnt);
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下四捨五入)
          this.totalCount = "累計：" + Math.round(this.totalValue1) + "連";
          break;
        case "生産者当たりむき身出荷量の比較":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            [
              "時期",
              annotation1 + "自分",
              annotation2 + "自分",
              annotation1 + "県平均",
            ],
            ["10月", 0, 0, 0],
            ["11月", 0, 0, 0],
            ["12月", 0, 0, 0],
            ["1月", 0, 0, 0],
            ["2月", 0, 0, 0],
            ["3月", 0, 0, 0],
            ["4月", 0, 0, 0],
            ["5月", 0, 0, 0],
            ["6月", 0, 0, 0],
          ];
          // 情報設定(集計対象のユーザー数をセットする)
          chartDataUsrCnt = [
            ["時期", "ユーザー数"],
            ["10月", 0],
            ["11月", 0],
            ["12月", 0],
            ["1月", 0],
            ["2月", 0],
            ["3月", 0],
            ["4月", 0],
            ["5月", 0],
            ["6月", 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            cnt_sub = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][1] =
                      chartDataSub[cnt][1] + row1.total_amount;
                    // 表示年1用累計数量を蓄積
                    this.totalValue1 = this.totalValue1 + row1.total_amount;
                  }
                  chartDataSub[cnt][3] =
                    chartDataSub[cnt][3] + row1.total_amount;
                  break;
                } else if (
                  ((row1.month_week_num.substring(0 ,2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))) &&
                  (row1.uid == this.uid)
                ) {
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
              for (row3 of chartDataUsrCnt) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")
                ) {
                  // 同月内は異なるユーザーのみカウントする
                  if (
                    rsvUser != row1.uid ||
                    rsvMw != row1.month_week_num.substring(0, 2)
                  ) {
                    chartDataUsrCnt[cnt_sub][1] =
                      chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = row1.month_week_num.substring(0, 2);
                  }
                  break;
                }
                cnt_sub++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row4 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row4[0].toString().replace("月", "")
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][2] =
                      chartDataSub[cnt][2] + row1.total_amount;
                    // 表示年2用累計数量を蓄積
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                  ) {
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                    break;
                  }
                cnt++;
              }
            }
          }
          // 県平均値を算出する(小数点第2位を四捨五入)
          this.culcAverage(chartDataSub,chartDataUsrCnt);
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1).toFixed(1) + "kg";
          break;
        case "総水揚げ連数の推移":
          // グラフ情報を設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            ["時期", annotation1 + "シーズン", annotation2 + "シーズン"],
            ["10月", 0, 0],
            ["11月", 0, 0],
            ["12月", 0, 0],
            ["1月", 0, 0],
            ["2月", 0, 0],
            ["3月", 0, 0],
            ["4月", 0, 0],
            ["5月", 0, 0],
            ["6月", 0, 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")
                ) {
                  chartDataSub[cnt][1] =
                    chartDataSub[cnt][1] + row1.total_amount;
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row3 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")
                ) {
                  chartDataSub[cnt][2] =
                    chartDataSub[cnt][2] + row1.total_amount;
                  // 表示年2用累計数量を蓄積
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下第2位四捨五入)
          this.totalCount = "累計：" + Math.round(this.totalValue1) + "連";
          break;
        case "殻付き出荷個数（生産者当たり）":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, true);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            [
              "時期",
              annotation1 + " S",
              annotation1 + " M",
              annotation1 + " L",
              annotation1 + " 2L",
              annotation2 + " S",
              annotation2 + " M",
              annotation2 + " L",
              annotation2 + " 2L",
            ],
            ["7月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["8月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["9月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["10月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["11月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["12月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["1月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["2月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["3月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["4月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["5月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
            ["6月", 0, 0, 0, 0, null, null, null, null],
            ["", null, null, null, null, 0, 0, 0, 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")
                ) {
                  if (row1.uid == this.uid) {
                    if (this.selectedDoubling == 1) {   // 普通（二倍体）
                      chartDataSub[cnt][1] = chartDataSub[cnt][1] + row1.total_amount_s;
                      chartDataSub[cnt][2] = chartDataSub[cnt][2] + row1.total_amount_m;
                      chartDataSub[cnt][3] = chartDataSub[cnt][3] + row1.total_amount_l;
                      chartDataSub[cnt][4] = chartDataSub[cnt][4] + row1.total_amount_2l;
                      // 表示年1用累計数量を蓄積
                      this.totalValue1 = this.totalValue1 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                    } else if (this.selectedDoubling == 2) {   // 三倍体
                      chartDataSub[cnt][1] = chartDataSub[cnt][1] + row1.total_amount_3n_s;
                      chartDataSub[cnt][2] = chartDataSub[cnt][2] + row1.total_amount_3n_m;
                      chartDataSub[cnt][3] = chartDataSub[cnt][3] + row1.total_amount_3n_l;
                      chartDataSub[cnt][4] = chartDataSub[cnt][4] + row1.total_amount_3n_2l;
                      // 表示年1用累計数量を蓄積
                      this.totalValue1 = this.totalValue1 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                    }
                  }
                  break;
                } else if (
                  ((row1.month_week_num.substring(0 ,2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))) &&
                  (row1.uid == this.uid)
                  ) {
                  /*
                  // 表示年1用累計数量を蓄積
                  if (this.selectedDoubling == 1) {   // 普通（二倍体）
                    this.totalValue1 = this.totalValue1 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                  } else if (this.selectedDoubling == 2) {   // 三倍体
                    this.totalValue1 = this.totalValue1 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                  }
                  break;
                  */
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row4 of chartDataSub) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row4[0].toString().replace("月", "")
                ) {
                  if (row1.uid == this.uid) {
                    if (this.selectedDoubling == 1) {   // 普通（二倍体）
                      chartDataSub[cnt+1][5] = chartDataSub[cnt+1][5] + row1.total_amount_s;
                      chartDataSub[cnt+1][6] = chartDataSub[cnt+1][6] + row1.total_amount_m;
                      chartDataSub[cnt+1][7] = chartDataSub[cnt+1][7] + row1.total_amount_l;
                      chartDataSub[cnt+1][8] = chartDataSub[cnt+1][8] + row1.total_amount_2l;
                      // 表示年2用累計数量を蓄積
                      this.totalValue2 = this.totalValue2 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                    } else if (this.selectedDoubling == 2) {   // 三倍体
                      chartDataSub[cnt+1][5] = chartDataSub[cnt+1][5] + row1.total_amount_3n_s;
                      chartDataSub[cnt+1][6] = chartDataSub[cnt+1][6] + row1.total_amount_3n_m;
                      chartDataSub[cnt+1][7] = chartDataSub[cnt+1][7] + row1.total_amount_3n_l;
                      chartDataSub[cnt+1][8] = chartDataSub[cnt+1][8] + row1.total_amount_3n_2l;
                      // 表示年2用累計数量を蓄積
                      this.totalValue2 = this.totalValue2 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                    }
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                  ) {
                  /*
                  // 表示年2用累計数量を蓄積
                  if (this.selectedDoubling == 1) {   // 普通（二倍体）
                    this.totalValue2 = this.totalValue2 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                  } else if (this.selectedDoubling == 2) {   // 三倍体
                    this.totalValue2 = this.totalValue2 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                  }
                  break;
                  */
                }
                cnt++;
              }
            }
          }

          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1) + "個";
          break;

        default:
          break;
      }
    },
    /**
     * 週別グラフ表示用データを設定する
     */
    setDataWeek(
      graphKindName,
      dispYear1,
      dispYear2,
      uid,
      summary_type,
      summary_data,
      product_record_update_date,
      dispPagenationFlag
    ) {
      this.graphKindName = graphKindName;
      this.dispYear1 = dispYear1;
      this.dispYear2 = dispYear2;
      this.uid = uid;
      this.summary_type = summary_type;
      this.summary_data = summary_data;
      this.product_record_update_date = product_record_update_date;
      this.dispPagenationFlag = dispPagenationFlag;

      // 週別ボタン選択状態
      this.tabIndex = 2;
      // 累計数量(対象シーズン毎)初期化
      this.totalValue1 = 0;
      this.totalValue2 = 0;
      // 前年比初期化
      this.yearOnyear = "";
      // 累計数量初期化
      this.totalValue = 0;
      // 出力メッセージ領域クリア
      this.clearMessage();

      // 凡例ラベル設定(R:令和)
      if (this.summary_data.length > 0) {
        var annotation1 = "R" + (this.dispYear1 - 2018);
        var annotation2 = "R" + (this.dispYear2 - 2018);
      }

      // 更新日時
      var productRecordUpdateDate = this.product_record_update_date.replaceAll(
        "-",
        "/"
      );

      // グラフ表示データ格納用
      var chartDataSub = [];
      var chartDataUsrCnt = [];
      var cnt, cnt_sub;
      var row1, row2, row3, row4;
      var cntlFalg = false;
      var mwData = "";
      var rsvUser = "";
      var rsvMw = "";
      this.date_type = "week";
      // 情報設定(APIで取得した情報をセット)
      var chartDataWeek1 = [
        // XXXX年XX月分データ
        ["XX月_X週", 0, 0],
      ];
      var chartDataWeek2 = [
        // XXXX年XX月分データ
        ["XX月_X週", 0, 0, 0],
      ];
      // 情報設定(集計対象のユーザー数をセットする)
      var chartDataUsrWeekCnt = [["XX月_X週", 0]];

      var month;
      var weekCnt;
      var cntSub;
      // 表示対象種別毎にグラフ(デフォルト用)情報を設定する
      switch (this.graphKindName) {
        case "むき身総出荷量の推移":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(ヘッダ情報をセットする)
          chartDataSub.push([
            "時期",
            annotation1 + "シーズン",
            annotation2 + "シーズン",
          ]);

          // 情報設定テーブル(YYYY年10月～(YYYY+1)年06月)を生成する
          for (cnt = 0; cnt < 9; cnt++) {
            month = 10 + cnt;
            if (3 <= cnt) {
              month = cnt - 2;
            }
            // 週数の設定(MAX:5)
            weekCnt = 5;

            for (cntSub = 0; cntSub < weekCnt; cntSub++) {
              chartDataWeek1[0] =
                month.toString() + "月_" + (cntSub + 1).toString() + "週";
              chartDataWeek1[1] = 0;
              chartDataWeek1[2] = 0;
              chartDataSub.push(chartDataWeek1);
              chartDataWeek1 = [];
            }
          }

          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                mwData = row2[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  chartDataSub[cnt][1] =
                    chartDataSub[cnt][1] + row1.total_amount;
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row3 of chartDataSub) {
                mwData = row3[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  chartDataSub[cnt][2] =
                    chartDataSub[cnt][2] + row1.total_amount;
                  // 表示年2用累計数量を蓄積
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }
          // グラフオブジェクトに表示データ設定
          this.chartDataRsv = chartDataSub;
          // 表示年2のデータが存在する場合のみ増減率算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1 / 1000).toFixed(1) + "トン";
          break;
        case "生産者当たり水揚げ量の比較":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(ヘッダ情報をセットする)
          chartDataSub.push([
            "時期",
            annotation1 + "自分",
            annotation2 + "自分",
            annotation1 + "県平均",
          ]);

          // 情報設定(ヘッダ情報をセットする)
          chartDataUsrCnt.push(["時期", "ユーザー数"]);

          // 情報設定テーブル(YYYY年10月～(YYYY+1)年06月)を生成する
          for (cnt = 0; cnt < 9; cnt++) {
            month = 10 + cnt;
            if (3 <= cnt) {
              month = cnt - 2;
            }
            // 週数の設定(MAX:5)
            weekCnt = 5;

            for (cntSub = 0; cntSub < weekCnt; cntSub++) {
              // API取得情報
              chartDataWeek2[0] =
                month.toString() + "月_" + (cntSub + 1).toString() + "週";
              chartDataWeek2[1] = 0;
              chartDataWeek2[2] = 0;
              chartDataWeek2[3] = 0;
              chartDataSub.push(chartDataWeek2);
              chartDataWeek2 = [];
              // ユーザー数
              chartDataUsrWeekCnt[0] =
                month.toString() + "月_" + (cntSub + 1).toString() + "週";
              chartDataUsrWeekCnt[1] = 0;
              chartDataUsrCnt.push(chartDataUsrWeekCnt);
              chartDataUsrWeekCnt = [];
            }
          }

          for (row1 of this.summary_data) {
            cnt = 0;
            cnt_sub = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                mwData = row2[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][1] =
                      chartDataSub[cnt][1] + row1.total_amount;
                    // 表示年1用累計数量を蓄積
                    this.totalValue1 = this.totalValue1 + row1.total_amount;
                  }
                  chartDataSub[cnt][3] =
                    chartDataSub[cnt][3] + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                ) {
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
              cnt_sub = 0;
              for (row3 of chartDataUsrCnt) {
                mwData = row3[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  // 同月内は異なるユーザーのみカウントする
                  if (rsvUser != row1.uid || rsvMw != row1.month_week_num) {
                    chartDataUsrCnt[cnt_sub][1] =
                      chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = row1.month_week_num;
                  }
                  break;
                }
                cnt_sub++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              cnt = 0;
              for (row4 of chartDataSub) {
                mwData = row4[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][2] =
                      chartDataSub[cnt][2] + row1.total_amount;
                    // 表示年2用累計数量を蓄積
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                ) {
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }
          // 県平均値を算出する(小数点第2位を四捨五入)
          this.culcAverage(chartDataSub,chartDataUsrCnt);
          // グラフオブジェクトに表示データ設定
          this.chartDataRsv = chartDataSub;
          // 表示年2のデータが存在する場合は累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下四捨五入)
          this.totalCount = "累計：" + Math.round(this.totalValue1) + "連";
          break;
        case "生産者当たりむき身出荷量の比較":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(ヘッダ情報をセットする)
          chartDataSub.push([
            "時期",
            annotation1 + "自分",
            annotation2 + "自分",
            annotation1 + "県平均",
          ]);

          // 情報設定(ヘッダ情報をセットする)
          chartDataUsrCnt.push(["時期", "ユーザー数"]);

          // 情報設定テーブル(YYYY年10月～(YYYY+1)年06月)を生成する
          for (cnt = 0; cnt < 9; cnt++) {
            month = 10 + cnt;
            if (3 <= cnt) {
              month = cnt - 2;
            }
            // 週数の設定(MAX:5)
            weekCnt = 5;

            for (cntSub = 0; cntSub < weekCnt; cntSub++) {
              // API取得情報
              chartDataWeek2[0] =
                month.toString() + "月_" + (cntSub + 1).toString() + "週";
              chartDataWeek2[1] = 0;
              chartDataWeek2[2] = 0;
              chartDataWeek2[3] = 0;
              chartDataSub.push(chartDataWeek2);
              chartDataWeek2 = [];
              // ユーザー数
              chartDataUsrWeekCnt[0] =
                month.toString() + "月_" + (cntSub + 1).toString() + "週";
              chartDataUsrWeekCnt[1] = 0;
              chartDataUsrCnt.push(chartDataUsrWeekCnt);
              chartDataUsrWeekCnt = [];
            }
          }

          for (row1 of this.summary_data) {
            cnt = 0;
            cnt_sub = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                mwData = row2[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][1] =
                      chartDataSub[cnt][1] + row1.total_amount;
                    // 表示年1用累計数量を蓄積
                    this.totalValue1 = this.totalValue1 + row1.total_amount;
                  }
                  chartDataSub[cnt][3] =
                    chartDataSub[cnt][3] + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                ) {
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
              cnt_sub = 0;
              for (row3 of chartDataUsrCnt) {
                mwData = row3[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  // 同月内は異なるユーザーのみカウントする
                  if (rsvUser != row1.uid || rsvMw != row1.month_week_num) {
                    chartDataUsrCnt[cnt_sub][1] =
                      chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = row1.month_week_num;
                  }
                  break;
                }
                cnt_sub++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              cnt = 0;
              for (row4 of chartDataSub) {
                mwData = row4[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][2] =
                      chartDataSub[cnt][2] + row1.total_amount;
                    // 表示年2用累計数量を蓄積
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                ) {
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }
          // 県平均値を算出する(小数点第2位を四捨五入)
          this.culcAverage(chartDataSub,chartDataUsrCnt);
          // グラフオブジェクトに表示データ設定
          this.chartDataRsv = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1).toFixed(1) + "kg";
          break;
        case "総水揚げ連数の推移":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(ヘッダ情報をセットする)
          chartDataSub.push([
            "時期",
            annotation1 + "シーズン",
            annotation2 + "シーズン",
          ]);

          // 情報設定テーブル(YYYY年10月～(YYYY+1)年06月)を生成する
          for (cnt = 0; cnt < 9; cnt++) {
            month = 10 + cnt;
            if (3 <= cnt) {
              month = cnt - 2;
            }
            // 週数の設定(MAX:5)
            weekCnt = 5;

            for (cntSub = 0; cntSub < weekCnt; cntSub++) {
              chartDataWeek1[0] =
                month.toString() + "月_" + (cntSub + 1).toString() + "週";
              chartDataWeek1[1] = 0;
              chartDataWeek1[2] = 0;
              chartDataSub.push(chartDataWeek1);
              chartDataWeek1 = [];
            }
          }

          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                mwData = row2[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  chartDataSub[cnt][1] =
                    chartDataSub[cnt][1] + row1.total_amount;
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row3 of chartDataSub) {
                mwData = row3[0].toString().replace("月_", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  chartDataSub[cnt][2] =
                    chartDataSub[cnt][2] + row1.total_amount;
                  // 表示年2用累計数量を蓄積
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))
                ) {
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }
          // グラフオブジェクトに表示データ設定
          this.chartDataRsv = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下第2位四捨五入)
          this.totalCount = "累計：" + Math.round(this.totalValue1) + "連";
          break;
        case "殻付き出荷個数（生産者当たり）":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, true);

          // 情報設定(ヘッダ情報をセットする)
          chartDataSub.push([
            "時期",
            annotation1 + " S",
            annotation1 + " M",
            annotation1 + " L",
            annotation1 + " 2L",
            annotation2 + " S",
            annotation2 + " M",
            annotation2 + " L",
            annotation2 + " 2L",
          ]);

          // 情報設定テーブル(YYYY年7月～(YYYY+1)年06月)を生成する
          for (cnt = 0; cnt < 12; cnt++) {
            month = 7 + cnt;
            if (6 <= cnt) {
              month = cnt - 5;
            }
            // 週数の設定(MAX:5)
            weekCnt = 5;

            for (cntSub = 0; cntSub < weekCnt; cntSub++) {
              // API取得情報
              chartDataSub.push([month.toString() + "月 " + (cntSub + 1).toString() + "週", 0,0,0,0, null ,null ,null ,null]);
              chartDataSub.push(["", null ,null ,null ,null,0,0,0,0]);
            }
          }

          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                mwData = row2[0].toString().replace("月 ", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  if (row1.uid == this.uid) {
                    if (this.selectedDoubling == 1) {   // 普通（二倍体）
                      chartDataSub[cnt][1] = chartDataSub[cnt][1] + row1.total_amount_s;
                      chartDataSub[cnt][2] = chartDataSub[cnt][2] + row1.total_amount_m;
                      chartDataSub[cnt][3] = chartDataSub[cnt][3] + row1.total_amount_l;
                      chartDataSub[cnt][4] = chartDataSub[cnt][4] + row1.total_amount_2l;
                      // 表示年1用累計数量を蓄積
                      this.totalValue1 = this.totalValue1 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                    } else if (this.selectedDoubling == 2) {   // 三倍体
                      chartDataSub[cnt][1] = chartDataSub[cnt][1] + row1.total_amount_3n_s;
                      chartDataSub[cnt][2] = chartDataSub[cnt][2] + row1.total_amount_3n_m;
                      chartDataSub[cnt][3] = chartDataSub[cnt][3] + row1.total_amount_3n_l;
                      chartDataSub[cnt][4] = chartDataSub[cnt][4] + row1.total_amount_3n_2l;
                      // 表示年1用累計数量を蓄積
                      this.totalValue1 = this.totalValue1 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                    }
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                  ) {
                  /*
                  // 表示年1用累計数量を蓄積
                  if (this.selectedDoubling == 1) {   // 普通（二倍体）
                    this.totalValue1 = this.totalValue1 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                  } else if (this.selectedDoubling == 2) {   // 三倍体
                    this.totalValue1 = this.totalValue1 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                  }
                  break;
                  */
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              cnt = 0;
              for (row4 of chartDataSub) {
                mwData = row4[0].toString().replace("月 ", "");
                mwData = mwData.replace("週", "");
                if (Number(row1.month_week_num) == mwData) {
                  if (row1.uid == this.uid) {
                    if (this.selectedDoubling == 1) {   // 普通（二倍体）
                      chartDataSub[cnt+1][5] = chartDataSub[cnt+1][5] + row1.total_amount_s;
                      chartDataSub[cnt+1][6] = chartDataSub[cnt+1][6] + row1.total_amount_m;
                      chartDataSub[cnt+1][7] = chartDataSub[cnt+1][7] + row1.total_amount_l;
                      chartDataSub[cnt+1][8] = chartDataSub[cnt+1][8] + row1.total_amount_2l;
                      // 表示年2用累計数量を蓄積
                      this.totalValue2 = this.totalValue2 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                    } else if (this.selectedDoubling == 2) {   // 三倍体
                      chartDataSub[cnt+1][5] = chartDataSub[cnt+1][5] + row1.total_amount_3n_s;
                      chartDataSub[cnt+1][6] = chartDataSub[cnt+1][6] + row1.total_amount_3n_m;
                      chartDataSub[cnt+1][7] = chartDataSub[cnt+1][7] + row1.total_amount_3n_l;
                      chartDataSub[cnt+1][8] = chartDataSub[cnt+1][8] + row1.total_amount_3n_2l;
                      // 表示年2用累計数量を蓄積
                      this.totalValue2 = this.totalValue2 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                    }
                  }
                  break;
                } else if (
                  (row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row1.uid == this.uid)
                  ) {
                  /*
                  // 表示年2用累計数量を蓄積
                  if (this.selectedDoubling == 1) {   // 普通（二倍体）
                    this.totalValue2 = this.totalValue2 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                  } else if (this.selectedDoubling == 2) {   // 三倍体
                    this.totalValue2 = this.totalValue2 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                  }
                  break;
                  */
                }
                cnt++;
              }
            }
          }

          // グラフオブジェクトに表示データ設定
          this.chartDataRsv = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1) + "個";
          break;

        default:
          break;
      }
    },
    /**
     * 累計グラフ表示用データを設定する
     */
    setDataTotal(
      graphKindName,
      dispYear1,
      dispYear2,
      uid,
      summary_type,
      summary_data,
      product_record_update_date,
      dispPagenationFlag
    ) {
      this.graphKindName = graphKindName;
      this.dispYear1 = dispYear1;
      this.dispYear2 = dispYear2;
      this.uid = uid;
      this.summary_type = summary_type;
      this.summary_data = summary_data;
      this.product_record_update_date = product_record_update_date;
      this.dispPagenationFlag = dispPagenationFlag;

      // 累計ボタン選択状態
      this.tabIndex = 3;
      // 累計数量(対象シーズン毎)初期化
      this.totalValue1 = 0;
      this.totalValue2 = 0;
      // 前年比初期化
      this.yearOnyear = "";
      // 累計数量初期化
      this.totalValue = 0;
      // 累計数量(累計グラフ用)初期化
      this.sumTotalAmount1 = 0;
      this.sumTotalAmount2 = 0;
      this.sumTotalAmount3 = 0;

      // 出力メッセージ領域クリア
      this.clearMessage();

      // 凡例ラベル設定(R:令和)
      if (this.summary_data.length > 0) {
        var annotation1 = "R" + (this.dispYear1 - 2018);
        var annotation2 = "R" + (this.dispYear2 - 2018);
      }

      // 更新日時
      var productRecordUpdateDate = this.product_record_update_date.replaceAll(
        "-",
        "/"
      );

      // グラフ表示データ格納用
      var chartDataSub = [];
      var chartDataUsrCnt = [];
      var cnt, cnt_sub;
      var row, row1, row2, row3, row4, row5, row7;
      var cntlFalg = false;
      var rsvUser = "";
      var rsvMw = "";
      const now = new DateWrapper(Date.now()).format;
      const currentYear = Number(now.systemDate.substring(0, 4));
      const currentMonth = Number(now.systemDate.substring(5, 7));
      var isCurrentSeason = false;
      this.date_type = "all";

      // 表示対象種別毎にグラフ(デフォルト用)情報を設定する
      switch (this.graphKindName) {
        case "むき身総出荷量の推移":
          // グラフの情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            ["時期", annotation1 + "シーズン", annotation2 + "シーズン"],
            ["10月", null, 0],
            ["11月", null, 0],
            ["12月", null, 0],
            ["1月", null, 0],
            ["2月", null, 0],
            ["3月", null, 0],
            ["4月", null, 0],
            ["5月", null, 0],
            ["6月", null, 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")) ||
                  (((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))) &&
                  (row2[0].substring(0, 3) == "10月"))
                ) {
                  chartDataSub[cnt][1] =
                    chartDataSub[cnt][1] + row1.total_amount;
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row3 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row3[0].substring(0, 3) == "10月"))
                ) {
                  chartDataSub[cnt][2] =
                    chartDataSub[cnt][2] + row1.total_amount;
                  // 表示年2用累計数量を蓄積
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }

          cnt = 0;
          isCurrentSeason = this.checkCurrentSeason(currentYear, currentMonth);
          for (row of chartDataSub){
            if (row[1] == null){
              chartDataSub[cnt][1] = 0;
            }
            if ((row[0].toString().replace("月", "") == currentMonth) &&
            isCurrentSeason){
              break;
            }
            cnt = cnt + 1;
          }

          // 各総量を蓄積して翌月の累計値として格納する
          cnt = 0;
          for (row5 of chartDataSub) {
            if (1 <= cnt) {
              this.sumTotalAmount1 = this.sumTotalAmount1 + row5[1];
              if (chartDataSub[cnt][1] != null) {
                chartDataSub[cnt][1] = this.sumTotalAmount1;
              }
              this.sumTotalAmount2 = this.sumTotalAmount2 + row5[2];
              if (chartDataSub[cnt][2] != null) {
                chartDataSub[cnt][2] = this.sumTotalAmount2;
              }
            }
            cnt++;
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          //表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1 / 1000).toFixed(1) + "トン";
          break;
        case "生産者当たり水揚げ量の比較":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            [
              "時期",
              annotation1 + "自分",
              annotation2 + "自分",
              annotation1 + "県平均",
            ],
            ["10月", null, 0, null],
            ["11月", null, 0, null],
            ["12月", null, 0, null],
            ["1月", null, 0, null],
            ["2月", null, 0, null],
            ["3月", null, 0, null],
            ["4月", null, 0, null],
            ["5月", null, 0, null],
            ["6月", null, 0, null],
          ];
          // 情報設定(集計対象のユーザー数をセットする)
          chartDataUsrCnt = [
            ["時期", "ユーザー数"],
            ["10月", 0],
            ["11月", 0],
            ["12月", 0],
            ["1月", 0],
            ["2月", 0],
            ["3月", 0],
            ["4月", 0],
            ["5月", 0],
            ["6月", 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            cnt_sub = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row2[0].substring(0, 3) == "10月"))
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][1] =
                      chartDataSub[cnt][1] + row1.total_amount;
                    // 表示年1用累計数量を蓄積
                    this.totalValue1 = this.totalValue1 + row1.total_amount;
                  }
                  chartDataSub[cnt][3] =
                    chartDataSub[cnt][3] + row1.total_amount;
                  break;
                }
                cnt++;
              }
              for (row3 of chartDataUsrCnt) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")
                ) {
                  // 同月内は異なるユーザーのみカウントする
                  if (
                    rsvUser != row1.uid ||
                    rsvMw != row1.month_week_num.substring(0, 2)
                  ) {
                    chartDataUsrCnt[cnt_sub][1] =
                      chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = row1.month_week_num.substring(0, 2);
                  }
                  break;
                } else if (
                  ((row1.month_week_num.substring(0 ,2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))) &&
                  (row3[0].substring(0, 3) == "10月")
                ) {
                  if (
                    rsvUser != row1.uid
                  ) {
                    chartDataUsrCnt[cnt_sub][1] =
                     chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = "10";
                  }
                  break;
                }
                cnt_sub++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row4 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row4[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row4[0].substring(0, 3) == "10月"))
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][2] =
                      chartDataSub[cnt][2] + row1.total_amount;
                    // 表示年2用累計数量を蓄積
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                  }
                  break;
                }
                cnt++;
              }
            }
          }

          cnt = 0;
          //表示年１が現シーズンか否かを判別
          isCurrentSeason = this.checkCurrentSeason(currentYear, currentMonth);
          for (row of chartDataSub){
            if (row[1] == null){
              chartDataSub[cnt][1] = 0;
            }
            if (row[3] == null){
              chartDataSub[cnt][3] = 0;
            }
            //表示年1が現シーズンかつrow[0]が当月であればforから抜ける
            if ((row[0].toString().replace("月", "") == currentMonth) &&
            isCurrentSeason){
              break;
            }
            cnt = cnt + 1;
          }

          // 県平均値を算出する(小数点第2位を四捨五入)
          this.culcAverage(chartDataSub,chartDataUsrCnt);
          // 各総量を蓄積して翌月の累計値として格納する
          cnt = 0;
          for (row7 of chartDataSub) {
            if (1 <= cnt) {
              this.sumTotalAmount1 = this.sumTotalAmount1 + row7[1];
              if (chartDataSub[cnt][1] != null) {
                chartDataSub[cnt][1] = this.sumTotalAmount1;
              }
              this.sumTotalAmount2 = this.sumTotalAmount2 + row7[2];
              if (chartDataSub[cnt][2] != null) {
                chartDataSub[cnt][2] = this.sumTotalAmount2;
              }
              this.sumTotalAmount3 = this.sumTotalAmount3 + row7[3];
              if (chartDataSub[cnt][3] != null) {
                chartDataSub[cnt][3] = this.sumTotalAmount3;
              }
            }
            cnt++;
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下四捨五入)
          this.totalCount = "累計：" + Math.round(this.totalValue1) + "連";
          break;
        case "生産者当たりむき身出荷量の比較":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            [
              "時期",
              annotation1 + "自分",
              annotation2 + "自分",
              annotation1 + "県平均",
            ],
            ["10月", null, 0, null],
            ["11月", null, 0, null],
            ["12月", null, 0, null],
            ["1月", null, 0, null],
            ["2月", null, 0, null],
            ["3月", null, 0, null],
            ["4月", null, 0, null],
            ["5月", null, 0, null],
            ["6月", null, 0, null],
          ];
          // 情報設定(集計対象のユーザー数をセットする)
          chartDataUsrCnt = [
            ["時期", "ユーザー数"],
            ["10月", 0],
            ["11月", 0],
            ["12月", 0],
            ["1月", 0],
            ["2月", 0],
            ["3月", 0],
            ["4月", 0],
            ["5月", 0],
            ["6月", 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            cnt_sub = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row2[0].substring(0, 3) == "10月"))
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][1] =
                      chartDataSub[cnt][1] + row1.total_amount;
                    // 表示年1用累計数量を蓄積
                    this.totalValue1 = this.totalValue1 + row1.total_amount;
                  }
                  chartDataSub[cnt][3] =
                    chartDataSub[cnt][3] + row1.total_amount;
                  break;
                }
                cnt++;
              }
              for (row3 of chartDataUsrCnt) {
                if (
                  Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")
                ) {
                  // 同月内は異なるユーザーのみカウントする
                  if (
                    rsvUser != row1.uid ||
                    rsvMw != row1.month_week_num.substring(0, 2)
                  ) {
                    chartDataUsrCnt[cnt_sub][1] =
                      chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = row1.month_week_num.substring(0, 2);
                  }
                  break;
                } else if (
                  ((row1.month_week_num.substring(0, 2) >= 7 ) &&
                   ( 9 >= row1.month_week_num.substring(0, 2))) &&
                   (row3[0].substring(0,3) == "10月") 
                ) {
                  if (
                    rsvUser != row1.uid
                    // rsvMw != row1.month_week_num.substring(0, 2)
                  ) {
                    chartDataUsrCnt[cnt_sub][1] =
                     chartDataUsrCnt[cnt_sub][1] + 1;
                    rsvUser = row1.uid;
                    rsvMw = "10";
                  }
                  break;
                }
                cnt_sub++;
              }
            } else if (
              (row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1)
            ) {
              cntlFalg = true;
              for (row4 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row4[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row4[0].substring(0, 3) == "10月"))
                ) {
                  if (row1.uid == this.uid) {
                    chartDataSub[cnt][2] =
                      chartDataSub[cnt][2] + row1.total_amount;
                    // 表示年2用累計数量を蓄積
                    this.totalValue2 = this.totalValue2 + row1.total_amount;
                  }
                  break;
                }
                cnt++;
              }
            }
          }

          cnt = 0;
          isCurrentSeason = this.checkCurrentSeason(currentYear, currentMonth);
          for (row of chartDataSub){
            if (row[1] == null){
              chartDataSub[cnt][1] = 0;
            }
            if (row[3] == null){
              chartDataSub[cnt][3] = 0;
            }
            //表示年1が現シーズンかつrow[0]が当月であればforから抜ける
            if ((row[0].toString().replace("月", "") == currentMonth) &&
            isCurrentSeason){
              break;
            }
            cnt = cnt + 1;
          }

          // 県平均値を算出する(小数点第2位を四捨五入)
          this.culcAverage(chartDataSub,chartDataUsrCnt);
          // 各総量を蓄積して翌月の累計値として格納する
          cnt = 0;
          for (row7 of chartDataSub) {
            if (1 <= cnt) {
              this.sumTotalAmount1 = this.sumTotalAmount1 + row7[1];
              if (chartDataSub[cnt][1] != null) {
                chartDataSub[cnt][1] = this.sumTotalAmount1;
              }
              this.sumTotalAmount2 = this.sumTotalAmount2 + row7[2];
              if (chartDataSub[cnt][2] != null) {
                chartDataSub[cnt][2] = this.sumTotalAmount2;
              }
              this.sumTotalAmount3 = this.sumTotalAmount3 + row7[3];
              if (chartDataSub[cnt][3] != null) {
                chartDataSub[cnt][3] = this.sumTotalAmount3;
              }
            }
            cnt++;
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1).toFixed(1) + "kg";
          break;
        case "総水揚げ連数の推移":
          //グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          chartDataSub = [
            ["時期", annotation1 + "シーズン", annotation2 + "シーズン"],
            ["10月", null, 0],
            ["11月", null, 0],
            ["12月", null, 0],
            ["1月", null, 0],
            ["2月", null, 0],
            ["3月", null, 0],
            ["4月", null, 0],
            ["5月", null, 0],
            ["6月", null, 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")) ||
                  (((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2))) &&
                  (row2[0].substring(0, 3) == "10月"))
                ) {
                  chartDataSub[cnt][1] =
                    chartDataSub[cnt][1] + row1.total_amount;
                  // 表示年1用累計数量を蓄積
                  this.totalValue1 = this.totalValue1 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            } else if (
              row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1
            ) {
              cntlFalg = true;
              for (row3 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row3[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row3[0].substring(0, 3) == "10月"))
                ) {
                  chartDataSub[cnt][2] =
                    chartDataSub[cnt][2] + row1.total_amount;
                  // 表示年2用累計数量を蓄積
                  this.totalValue2 = this.totalValue2 + row1.total_amount;
                  break;
                }
                cnt++;
              }
            }
          }

          cnt = 0;
          // 表示年1が現在シーズンかどうかを判定
          isCurrentSeason = this.checkCurrentSeason(currentYear, currentMonth);
          for (row of chartDataSub){
            if (row[1] == null){
              chartDataSub[cnt][1] = 0;
            }
            if ((row[0].toString().replace("月", "") == currentMonth) &&
            isCurrentSeason){
              break;
            }
            cnt = cnt + 1;
          }

          // 各総量を蓄積して翌月の累計値として格納する
          cnt = 0;
          for (row5 of chartDataSub) {
            if (1 <= cnt) {
              this.sumTotalAmount1 = this.sumTotalAmount1 + row5[1];
              if (chartDataSub[cnt][1] != null) {
                chartDataSub[cnt][1] = this.sumTotalAmount1;
              }
              this.sumTotalAmount2 = this.sumTotalAmount2 + row5[2];
              if (chartDataSub[cnt][2] != null) {
                chartDataSub[cnt][2] = this.sumTotalAmount2;
              }
            }
            cnt++;
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点以下第2位四捨五入)
          this.totalCount = "累計：" + Math.round(this.totalValue1) + "連";
          break;
        case "殻付き出荷個数（生産者当たり）":
          // グラフ情報設定
          this.setChartSettings(this.summary_type, this.date_type, false);

          // 情報設定(APIで取得した情報をセットする)
          chartDataSub = [
            [
              "時期",
              annotation1 + "シーズン",
              annotation2 + "シーズン",
            ],
            ["7月", null, 0],
            ["8月", null, 0],
            ["9月", null, 0],
            ["10月", null, 0],
            ["11月", null, 0],
            ["12月", null, 0],
            ["1月", null, 0],
            ["2月", null, 0],
            ["3月", null, 0],
            ["4月", null, 0],
            ["5月", null, 0],
            ["6月", null, 0],
          ];
          for (row1 of this.summary_data) {
            cnt = 0;
            if (
              !cntlFalg &&
              ((row1.comparison_year == Number(this.dispYear1) && row1.month_week_num.substring(0, 2) >= 7) ||
                ((row1.comparison_year == Number(this.dispYear1) + 1) && row1.month_week_num.substring(0, 2) <= 6))
            ) {
              for (row2 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row2[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row2[0].substring(0, 3) == "10月"))
                ) {
                  if (row1.uid == this.uid) {
                    // 表示年1用累計数量を蓄積
                    if (this.selectedDoubling == 1) {   // 普通（二倍体）
                      chartDataSub[cnt][1] = chartDataSub[cnt][1] + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                      this.totalValue1 = this.totalValue1 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                    } else if (this.selectedDoubling == 2) {   // 三倍体
                      chartDataSub[cnt][1] = chartDataSub[cnt][1] + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                      this.totalValue1 = this.totalValue1 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                    }
                  }
                  break;
                }
                cnt++;
              }
            } else if (
              (row1.comparison_year == Number(this.dispYear2) ||
              row1.comparison_year == Number(this.dispYear2) + 1)
            ) {
              cntlFalg = true;
              for (row4 of chartDataSub) {
                if (
                  (Number(row1.month_week_num.substring(0, 2)) ==
                  row4[0].toString().replace("月", "")) ||
                  ((row1.month_week_num.substring(0, 2) >= 7) &&
                  (9 >= row1.month_week_num.substring(0, 2)) &&
                  (row4[0].substring(0, 3) == "10月"))
                ) {
                  if (row1.uid == this.uid) {
                    // 表示年2用累計数量を蓄積
                    if (this.selectedDoubling == 1) {   // 普通（二倍体）
                      chartDataSub[cnt][2] =chartDataSub[cnt][2] + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                      this.totalValue2 = this.totalValue2 + row1.total_amount_s + row1.total_amount_m + row1.total_amount_l + row1.total_amount_2l;
                    } else if (this.selectedDoubling == 2) {   // 三倍体
                      chartDataSub[cnt][2] =chartDataSub[cnt][2] + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                      this.totalValue2 = this.totalValue2 + row1.total_amount_3n_s + row1.total_amount_3n_m + row1.total_amount_3n_l + row1.total_amount_3n_2l;
                    }
                  }
                  break;
                }
                cnt++;
              }
            }
          }

          cnt = 0;
          isCurrentSeason = this.checkCurrentSeason(currentYear, currentMonth);
          for (row of chartDataSub){
            if (row[1] == null){
              chartDataSub[cnt][1] = 0;
            }
            //表示年1が現シーズンかつrow[0]が当月であればforから抜ける
            if ((row[0].toString().replace("月", "") == currentMonth) &&
            isCurrentSeason){
              break;
            }
            cnt = cnt + 1;
          }

          // 各総量を蓄積して翌月の累計値として格納する
          cnt = 0;
          for (row7 of chartDataSub) {
            if (1 <= cnt) {
              this.sumTotalAmount1 = this.sumTotalAmount1 + row7[1];
              if (chartDataSub[cnt][1] != null) {
                chartDataSub[cnt][1] = this.sumTotalAmount1;
              }
              this.sumTotalAmount2 = this.sumTotalAmount2 + row7[2];
              if (chartDataSub[cnt][2] != null) {
                chartDataSub[cnt][2] = this.sumTotalAmount2;
              }
            }
            cnt++;
          }
          // グラフオブジェクトに表示データ設定
          this.chartData = chartDataSub;
          // 表示年2のデータが存在する場合累計値の増減率を算出
          this.calcCompareTotalValue();

          // 詳細情報設定(999.99、YYYY/MM/DD hh:mm)
          if (this.summary_data.length > 0) {
            this.detailData =
              "(" +
              this.dispYear2 +
              "年 " +
              this.yearOnyear +
              "%) " +
              productRecordUpdateDate.substring(0, 16) +
              "現在";
          }
          // 累計数量設定(小数点第2位四捨五入)
          this.totalCount =
            "累計：" + parseFloat(this.totalValue1) + "個";
          break;

        default:
          break;
      }
    },

    /**
     * グラフ出力(月別)
     */
    monthlyOutput() {
      this.setDataMonth(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.uid,
        this.summary_type,
        this.summary_data,
        this.product_record_update_date,
        (this.dispPagenationFlag = false)
      );
    },
    /**
     * グラフ出力(週別)
     */
    weeklyOutput() {
      this.setDataWeek(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.uid,
        this.summary_type,
        this.summary_data,
        this.product_record_update_date,
        (this.dispPagenationFlag = true)
      );

      if (this.fromChangeDoubling && this.selectMonthRsv != "0") {
        this.fromChangeDoubling = false;
        this.dispGraphData(this.selectMonthRsv);
      } else {
        let withShell = this.graphKindName === "殻付き出荷個数（生産者当たり）"
        // 初期は現在月分を表示
        const now = new DateWrapper(Date.now()).format;
        const month_sub = Number(now.systemDate.substring(5, 7));
        // 現在月が7月～9月の場合は10月分を表示する
        if (7 <= month_sub && month_sub <= 9 && !withShell) {
          this.month = this.dispYear1.substring(0, 4) + "-10";
        //現在月が1月~6月の場合は表示年1に＋1する
        //令和4年度の場合 2022年10月~2023年6月がシーズンとなるため
        } else if (1 <= month_sub <= 6) {
          const year_sub = Number(this.dispYear1) + 1 ;
          this.month =
            year_sub + "-" + now.systemDate.substring(5, 7);
        //現在月が10月~12月の場合は表示年1の当月分を表示する
        } else {
          this.month =
            this.dispYear1.substring(0, 4) + "-" + now.systemDate.substring(5, 7);
        }
        this.$refs.month_picker_graph.updateSearchMonth(
          this.dispYear1.substring(0, 4),
          this.month,
          false,
          withShell
        );
      }
    },
    /**
     * グラフ出力(累計)
     */
    totalOutput() {
      this.setDataTotal(
        this.graphKindName,
        this.dispYear1,
        this.dispYear2,
        this.uid,
        this.summary_type,
        this.summary_data,
        this.product_record_update_date,
        (this.dispPagenationFlag = false)
      );
    },
    /**
     * グラフ種類別キー設定
     */
    getTabItems() {
      let items = [];

      items.push({
        label: "月別",
        key: "1",
        callback: () => this.monthlyOutput(),
      });
      items.push({
        label: "週別",
        key: "2",
        callback: () => this.weeklyOutput(),
      });
      items.push({
        label: "累計",
        key: "3",
        callback: () => this.totalOutput(),
      });

      return items;
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },

    /**
     * グラフの設定を行う
     */
    setChartSettings(summaryType, graphType, isStacked) {
      // グラフの種類設定
      if (graphType == "all"){
        this.chartType = "LineChart";
        // フォーカスターゲットをカテゴリに設定
        this.chartOptions.focusTarget = 'category';
      } else{
        this.chartType = "ColumnChart";
        // フォーカスターゲットをデータムに設定
        this.chartOptions.focusTarget = 'datum';
      }
      
      // グラフの横幅設定
      this.chartOptions.width = 420;
      // グラフの高さ設定
      this.chartOptions.height = 350;
      // グラフ表示枠の左端からの有効位置(px)と領域使用率
      this.chartOptions.chartArea = {
        left: 85,
        width: "100%",
      };
      // グラフ棒各幅設定
      this.chartOptions.bar = {
        groupWidth: "80%",
      };
      // 左右のY軸表示の設定
      this.chartOptions.series = {};
      this.chartOptions.vAxes = {};

      // Y軸の単位表示の設定
      if (summaryType == "UNLOADING") {
        this.chartOptions.vAxis = {
          title: "[連]",
          titleTextStyle: { italic: false },
        };
      } else if (summaryType == "SHIPPING") {
        if (isStacked) {
          this.chartOptions.vAxis = {
            title: "[個]",
            titleTextStyle: { italic: false },
          };
        } else {
          this.chartOptions.vAxis = {
            title: "[kg]",
            titleTextStyle: { italic: false },
          };
        }
      }

      // 積み上げ棒グラフの設定
      this.chartOptions.isStacked = isStacked;
      if (isStacked) {
          this.chartOptions.width = 450;
          this.chartOptions.legend = {position:'top', maxLines: 2, textStyle: {fontSize: 14}};
          this.chartOptions.colors = ["#3366CC","#5588EE","#77AAFF","#99CCFF","#FF9900","#FFBB22","#FFDD44","#FFFF66"];
          this.chartOptions.series = ["string","number","number","number","number","number","number","number","number"];
      } else {
          this.chartOptions.legend = {position:'bottom'};
          this.chartOptions.colors = ["#3366CC","#FF9900","#109618"];
      }
    },

    /**
     * 累計値の増減率を算出する
     */
     calcCompareTotalValue() {
      if (this.totalValue2 > 0) {
        // 累計値の増減率算出[(((表示年1累計値/表示年2累計値) - 1) * 100)(%)]
        this.totalValue = (this.totalValue1 / this.totalValue2 - 1) * 100;
        if (this.totalValue > 0) {
          this.yearOnyear = "+" + parseFloat(this.totalValue).toFixed(2);
        } else if (this.totalValue == 0) {
          this.yearOnyear = "±" + parseFloat(this.totalValue).toFixed(2);
        } else {
          this.yearOnyear = parseFloat(this.totalValue).toFixed(2);
        }
      } else {
        // 表示年2の累計値が0の場合は増減率は非表示とする
        this.yearOnyear = "--.--";
      }
    },

    /**
     * 表示年1が現在シーズンか判定する
     */
     checkCurrentSeason(currentYear, currentMonth) {
      if ((this.dispYear1 == currentYear && currentMonth >= 10) ||
      (((Number(this.dispYear1) + 1) == currentYear) &&
      (currentMonth <= 6))
      ) {
        return true;
      } else {
        return false;
      }
    },
    
    /**
     * 県平均を算出する
     */
    culcAverage(chartDataSub, chartDataUsrCnt) {
      var cnt = 0;
      var row = "";
      for (row of chartDataSub) {
        if (1 <= cnt && row[3] != 0) {
          if (chartDataUsrCnt[cnt][1] != 0) {
            chartDataSub[cnt][3] = Number(
              parseFloat(row[3] / chartDataUsrCnt[cnt][1]).toFixed(1)
            );
          }
        }
        cnt++;
      }
    },

    /**
     * 県平均を算出する(積み上げグラフ)
     */
    culcAverageStacked(chartDataSub, chartDataUsrCnt) {
      var cnt = 0;
      var usrcnt = 0;
      var row = "";

      for (row of chartDataSub) {
        if (1 <= cnt && 
            row[7] != null && row[8] != null && row[9] != null &&
            (row[7] != 0 || row[8] != 0 ||row[9] != 0)) {
          usrcnt = cnt/3;
          if (chartDataUsrCnt[usrcnt][1] != 0) {
            chartDataSub[cnt][7] = Number(parseFloat(row[7] / chartDataUsrCnt[usrcnt][1]).toFixed(1));
            chartDataSub[cnt][8] = Number(parseFloat(row[8] / chartDataUsrCnt[usrcnt][1]).toFixed(1));
            chartDataSub[cnt][9] = Number(parseFloat(row[9] / chartDataUsrCnt[usrcnt][1]).toFixed(1));
          }
        }
        cnt++;
      }
    },

    /**
     * 区分(1:通常（二倍体）2:三倍体)を切り替える
     */
    onChangeDoubling() {

      this.fromChangeDoubling = true;
      switch (this.tabIndex) {
        case 1:
          this.monthlyOutput();
          break;
        case 2:
          this.weeklyOutput();
          break;
        case 3:
          this.totalOutput();
          break;
      }
    },
  },
  computed: {
    tabItems() {
      return this.getTabItems();
    },
  },
};
</script>

<style scoped>
.tab-item {
  width: 150px;
}
.tab-active {
  color: white !important;
  background-color: primary !important;
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>

